// @core/api/endpoints/subscription/get_plan.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlanResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get subscription plan details
 * Retrieves complete details of a subscription plan including pricing, features, limits, and billing configuration.
 * @public This endpoint does not require authentication
 */
export async function GetPlan(
  plan_id: string,
  options?: RequestOptions
): Promise<PlanResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/plans/:plan_id`;
  requestPath = requestPath.replace(':plan_id', encodeURIComponent(plan_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<PlanResponse>(requestPath, { ...requestOptions });
}
